var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCreateTicketStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40930",
    "data-name": "Group 40930",
    transform: "translate(-334 -595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15542",
    "data-name": "Rectangle 15542",
    width: 20,
    height: 20,
    transform: "translate(334 595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(335.266 596.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_42",
    d: "M63.875,68.107c-5.933.192-16.6-10.393-11.645-16.139l.839-.728a2.243,2.243,0,0,1,3.152.034c.021.021,1.372,1.776,1.372,1.776a2.259,2.259,0,0,1,0,3.122l-.758.9a1.008,1.008,0,0,0-.132,1.09,9.294,9.294,0,0,0,4.17,4.179.993.993,0,0,0,1.09-.132l.907-.762a2.263,2.263,0,0,1,3.122,0s1.755,1.35,1.776,1.372a2.262,2.262,0,0,1,0,3.19l-.664.762A4.509,4.509,0,0,1,63.875,68.107Z",
    transform: "translate(-50.954 -50.61)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(9.343 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37007",
    "data-name": "Path 37007",
    d: "M6.432,6.708a.338.338,0,0,0-.339.339V9.755a.339.339,0,0,1-.339.339H1.016a.339.339,0,0,1-.339-.339V5.016a.339.339,0,0,1,.339-.339H3.724a.339.339,0,0,0,0-.677H1.016A1.017,1.017,0,0,0,0,5.016v4.74a1.017,1.017,0,0,0,1.016,1.016h4.74A1.017,1.017,0,0,0,6.771,9.755V7.047A.338.338,0,0,0,6.432,6.708Z",
    transform: "translate(0 -2.646)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37008",
    "data-name": "Path 37008",
    d: "M8.811,5.856a.171.171,0,0,0-.046.086l-.239,1.2a.169.169,0,0,0,.166.2.16.16,0,0,0,.033,0l1.2-.239a.168.168,0,0,0,.087-.046l2.679-2.679-1.2-1.2Z",
    transform: "translate(-5.637 -2.102)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37009",
    "data-name": "Path 37009",
    d: "M20.014.248a.847.847,0,0,0-1.2,0l-.469.469,1.2,1.2.469-.469a.846.846,0,0,0,0-1.2Z",
    transform: "translate(-12.137 -0.001)",
    fill: "#1564e8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCreateTicketStatus);
export default __webpack_public_path__ + "static/media/phone-create-ticket-status.aeb7925a8e1efcf2d8ed61c7a72c79c7.svg";
export { ForwardRef as ReactComponent };